import styled from '@emotion/styled';
import { Breakpoints } from '../../../styles/variables/breakpoints';

const { sm, lg } = Breakpoints;

type Props = {
    flexStart: boolean;
};

export const OuterDiv = styled.div`
    padding: 0 24px;

    @media (max-width: ${lg}) {
        padding: 0 16px;
    }
`;

export const InnerDiv = styled.div<Props>`
    display: ${({ flexStart }) => (flexStart ? 'inline-flex' : 'flex')};
    flex-direction: row;
    justify-content: ${({ flexStart }) => (flexStart ? 'flex-start' : 'space-between')};
    align-items: center;
    padding: 16px 0;
    box-sizing: border-box;
    width: ${({ flexStart }) => (flexStart ? 'max-content' : '100%')};

    @media (max-width: ${sm}) {
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 16px 0 12px;
    }
`;
